import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import CreateTagForm from './create';
import { Divider, Layout, SelectReduxFormWrapper, Typography, Button } from '@hub-mono/ui';

class Tag extends PureComponent {
    static propTypes = {
        tags: PropTypes.array.isRequired,
        formName: PropTypes.string,
        fieldName: PropTypes.string,
        category: PropTypes.oneOf(['PROJECT', 'RESOURCE']).isRequired,
    };

    constructor(props) {
        super(props);
        this.state = { isFormOpen: false };
    }

    toggleForm = () => this.setState(state => ({ isFormOpen: !state.isFormOpen }));

    render() {
        const { isFormOpen } = this.state;
        const { tags, formName, fieldName, category, withBottomDivider } = this.props;

        return (
            <Layout stack gap={24} pt={24}>
                <Layout gap="--Spacing-150" stack>
                    {isFormOpen ? (
                        <CreateTagForm
                            formName={formName}
                            fieldName={fieldName}
                            category={category}
                            onDismiss={this.toggleForm}
                        />
                    ) : (
                        <>
                            <Typography variant="label" size="large" prominent>
                                Add Tags
                            </Typography>
                            <Layout stack gap={24}>
                                <Field
                                    name="tags"
                                    multiple
                                    component={SelectReduxFormWrapper}
                                    caseSensitive={false}
                                    dataCy="res-modal-tags"
                                    dropUp
                                    optionValue="_id"
                                    filter="contains"
                                    optionLabel={item => (Object.keys(item).length ? item.value : '')}
                                    options={tags}
                                    helperText="Type to enter a tag and select it. Or add a new tag."
                                />
                                <Layout>
                                    <Button
                                        onClick={this.toggleForm}
                                        variant="text"
                                        startIcon="add"
                                        dataCy="add-new-tag"
                                    >
                                        Add new Tag
                                    </Button>
                                </Layout>
                            </Layout>
                        </>
                    )}
                </Layout>
                {withBottomDivider ? <Divider /> : null}
            </Layout>
        );
    }
}

export default Tag;
